
export default {
	state: {
		accessErrorStatusCode: -1,
		countries: [],
	},

	mutations: {
		setAccessErrorStatusCode(state, accessErrorStatusCode) {
			state.accessErrorStatusCode = accessErrorStatusCode;
		},
		setCountries(state, countries) {
			state.countries = countries;
		},
	},
	actions: {
		globalInitialize({ commit }) {
			window.addEventListener('storage', (event) => {
				commit('setAccessErrorStatusCode', parseInt(event.newValue, 10));
			});
		},
		setAccessErrorStatusCode({ commit, dispatch }, accessErrorStatusCode) {
			window.localStorage.setItem('accessErrorStatusCode', accessErrorStatusCode.toString());
			commit('setAccessErrorStatusCode', accessErrorStatusCode);
		},
		fetchCountries({ commit, state, rootState }) {
			return new Promise((resolve) => {
				/* Sofern die Länderliste bereits geladen wurde,
				   müssen wir sie nicht erneut anfragen und signalisieren ein 'resolve' */
				if (state.countries.length > 0) {
					resolve();
					return;
				}

				/* TODO: Auslagerung in eigenen Request,
				         anstatt Länderliste aus Objektsetup-Daten zu ziehen */
				const countries =
					(rootState.objectsetup.current.land || [])
						.sort((a, b) => {
							const aLower = a.S_Land.toLowerCase();
							const bLower = b.S_Land.toLowerCase();
							const minLength = Math.min(aLower.length, bLower.length);

							let i = 0;
							while (i < minLength) {
								const diff = aLower.charCodeAt(i) - bLower.charCodeAt(i);
								if (diff !== 0) {
									return diff;
								}
								i += 1;
							}

							return aLower.length - bLower.length;
						})
						.map((country) => {
							country.S_Land = country.S_Land
								.split('_')
								.map(part => `${part[0].toUpperCase()}${part.substr(1)}`)
								.join(' ');
							return country;
						});
				commit('setCountries', countries);
				resolve();
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js